// extracted by mini-css-extract-plugin
module.exports =  {"spinnerContainer":"LjSpinner-module_spinnerContainer_f3480","overlay":"LjSpinner-module_overlay_a0693","spinner":"LjSpinner-module_spinner_acf0b"};